export default {"src":"/_next/static/media/data-recovery-testing.bab0ac91.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};